const Bone = ({ className }: { className: string }) => (
  <div className={`rounded bg-whisper ${className}`} />
);

const KPI_PLACEHOLDERS = [0, 1, 2];
const TABLE_ROW_PLACEHOLDERS = [0, 1, 2];

/**
 * Stands in for the report body between the first frame, which opens the panel,
 * and the first component, which is what there is to draw.
 */
export function ReportSkeleton() {
  return (
    <output
      aria-label="Report is being prepared"
      data-testid="report-skeleton"
      className="flex animate-pulse flex-col gap-6 motion-reduce:animate-none"
    >
      <div className="flex flex-col gap-2">
        <Bone className="h-6 w-2/3" />
        <Bone className="h-3 w-full" />
        <Bone className="h-3 w-5/6" />
      </div>

      <div className="grid grid-cols-3 gap-3">
        {KPI_PLACEHOLDERS.map((key) => (
          <Bone key={key} className="h-20 rounded-lg" />
        ))}
      </div>

      <Bone className="h-48 rounded-lg" />

      <div className="flex flex-col gap-2">
        {TABLE_ROW_PLACEHOLDERS.map((key) => (
          <Bone key={key} className="h-4 w-full" />
        ))}
      </div>
    </output>
  );
}
